module.exports = __webpack_public_path__ + "img/slidesmall.1ba5427e.webp";